import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    mailingGroups: [],
    mailingGroupsLoaded: false,
    clients: [],
    clientsCount: 0,
    mailingGroupModelDef: {
        id: null,
        bot_id: null,
        group_id: null,
        type: 1,
        title: '',
        temp_ids: null,
        title_page: null,
        button_subscribe: '',
        message_subscribe: 0,
        button_unsubscribe: '',
        message_unsubscribe: 0,
        image: null,
        visible_count_subscribe: 1,
        visible_group: 1,
        description: '',
        main: 0,
        creator: null,
        dialog_id: null,
        platform: 'vk',
        mailing_group_ids: []
    },
    tree: []
}
export default {
    state,
    getters,
    actions,
    mutations
}
